import React, { Component } from 'react'

import { consoleEvents } from '@pb/utils'

import GeneralError from '../GeneralError'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
    }
  }

  // getDerivedStateFromError is called when a decendant component throws an error during rendering
  static getDerivedStateFromError(): { hasError: boolean } {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, info): void {
    this.setState({
      hasError: true,
    })
    consoleEvents.error('Could not render component due to error', error)
    consoleEvents.error('Component stack for error above', info.componentStack)
  }

  render(): React.ReactNode {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasError' does not exist on type 'Readon... Remove this comment to see the full error message
      state: { hasError },
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'fallback' does not exist on type 'Readon... Remove this comment to see the full error message
      props: { fallback, children },
    } = this
    if (hasError) {
      return fallback
    }
    return children
  }
}
// @ts-expect-error ts-migrate(2339) FIXME: Property 'defaultProps' does not exist on type 'ty... Remove this comment to see the full error message
ErrorBoundary.defaultProps = {
  fallback: <GeneralError />,
}
export default ErrorBoundary
